"use client";

import Link from "next/link";
import { get_duration_time_server } from "@core/helpers/server/date";
import ImageComponent from "@core/helpers/client/components/image";
import Title from "@/components/Title";

const MostVisitedBlog = ({ fields, collection_data, isHomeBlog }) => {
  // بلاگ‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
  const blogs = collection_data?.blogs || [];

  return (
    <aside
      className={`w-full ${isHomeBlog ? "px-4 md:px-10 lg:px-0" : ""
        }`}
    >
      <div className="rounded-md lg:border border-jmt-neutral-200 lg:p-4 bg-white">

        {/* Title */}
        <div className="flex items-center lg:justify-center mb-3">
          <Title
            type={fields?.title?.type}
            className="text-center text-jmt-main font-bold border-b-2 border-jmt-primary-800 pb-1 text-sm md:text-base"
          >
            {fields?.title?.title || "پربازدیدترین‌ها"}
          </Title>
        </div>

        {/* Blog Cards */}
        <ul
          className="
            flex
            flex-row
            gap-3
            overflow-x-auto
            py-2
            hide-scrollbar
            lg:flex-col
            lg:gap-0
            lg:overflow-visible
            lg:space-y-2
          "
        >
          {blogs?.slice(0, 5)?.map((blog, index) => (
            <li
              key={index}
              className="
                shrink-0
                w-[280px]
                border
                border-jmt-neutral-200
                rounded-md
                p-3
                bg-white

                lg:w-full
                lg:border-0
                not-last:lg:border-b
                lg:border-jmt-neutral-200
                lg:rounded-none
                lg:p-0
                lg:pb-2
              "
            >
              <Link
                href={
                  blog?.seo?.full_url ||
                  blog?.seo?.url ||
                  "#"
                }
                className="
                  flex
                  items-start
                  gap-2
                  h-20
                  group
                "
              >
                {/* Image */}
                <div
                  className="
                    relative
                    w-20
                    h-20
                    shrink-0
                    rounded-md
                    overflow-hidden
                    bg-jmt-neutral-100
                  "
                >
                  <ImageComponent
                    src={blog?.media?.url || ""}
                    alt={
                      blog?.media?.alt ||
                      blog?.title ||
                      ""
                    }
                    // قاب w-20 (80px)
                    sizes="80px"
                    width={100}
                    height={100}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    className="object-cover"
                  />
                </div>

                {/* Content */}
                <div
                  className="
                    flex
                    flex-col
                    items-start
                    justify-between
                    h-full
                    flex-1
                    min-w-0
                  "
                >
                  <p
                    className="
                      font-bold
                      text-jmt-main
                      text-sm
                      line-clamp-2
                      transition-colors
                      group-hover:text-jmt-primary-800
                    "
                  >
                    {blog?.title}
                  </p>

                  <time
                    dateTime={
                      blog?.publishAt || "2025-10-01"
                    }
                    className="
                      text-[13px]
                      text-jmt-neutral-600
                    "
                  >
                    {get_duration_time_server(
                      blog?.publishAt
                    )}
                  </time>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default MostVisitedBlog;